import { colors } from '@components/theme/styles/index';
import { Box, styled } from '@mui/material';
import { rem } from 'polished';

export const AttachmentItem = styled('div')(
  ({ theme }) =>
    ({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      minHeight: rem(50),
      height: 'fit-content',
      padding: `0 ${rem(20)}`,
      borderBottom: `1px solid ${colors.grayLight1}`,
      [theme.breakpoints.down('md')]: {
        padding: `${rem(10)} ${rem(5)}`,
        gap: rem(5),
      },
    }) as any,
);

export const StyledBox = styled(Box)(
  ({ theme }) =>
    ({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      columnGap: rem(5),
      '> span': {
        color: colors.grayDark2,
      },
      [theme.breakpoints.down('md')]: {
        '> p': {
          maxWidth: rem(110),
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        },
      },
    }) as any,
);
